export default __webpack_public_path__ + "static/media/pares-de-rimas.76ee3666.png";